import script from "./CollegesListProfessionalismScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./CollegesListProfessionalismScreen.vue?vue&type=script&setup=true&lang=js"

import "./CollegesListProfessionalismScreen.vue?vue&type=style&index=0&id=4129c074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4129c074"]])

export default __exports__